import type { ReactNode } from 'react'

import type { PageAdPage } from '@/api/page-ads'
import { PageAdsSection } from '@/features/page-ads/components/PageAdsBlock'
import { CATALOG_LIST_PAGE_CLASS } from '@/shared/components/catalog/catalogListGrid'
import { cn } from '@/shared/lib/utils'

type Props = {
  children: ReactNode
  className?: string
  adsPage?: PageAdPage
  footer?: ReactNode
}

/** 业务列表页全宽壳：广告 + 内容，无 max-w 限制 */
export function CatalogListPageShell({ children, className, adsPage, footer }: Props) {
  return (
    <div className={cn(CATALOG_LIST_PAGE_CLASS, className)}>
      {adsPage ? <PageAdsSection page={adsPage} className="mb-3" /> : null}
      {children}
      {footer}
    </div>
  )
}
